var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectionRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.357216 0.719578C-0.0532198 0.999898 -0.119765 1.5112 0.208584 1.8616L4.80875 6.7707L0.208584 11.6798C-0.119765 12.0302 -0.0532204 12.5415 0.357216 12.8218C0.767652 13.1021 1.36656 13.0453 1.6949 12.6949L6.77069 7.27827C7.04875 6.98153 7.04875 6.55988 6.77069 6.26314L1.6949 0.846469C1.36656 0.496069 0.767652 0.439258 0.357216 0.719578Z",
    fill: "#4D20D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionRight);
export default __webpack_public_path__ + "static/media/direction-right.84f65a1941ea32f86d2f42b1f51404b0.svg";
export { ForwardRef as ReactComponent };